
import Message from '@/models/MessageModel';
import { defineComponent, PropType } from 'vue';
import MessageImage from '@/components/MessageImage.vue';
import MessageVideo from '@/components/MessageVideo.vue';
import MessageReport from '@/components/MessageReport.vue';

export default defineComponent({
	name: 'trigger-message-content-wrap',

	components: {
		MessageReport,
		MessageImage,
		MessageVideo
	},

	props: {
		message: {
			type: Object as PropType<Message>,
			required: true
		},

		isFirst: {
			type: Boolean,
			required: true
		}
	},

	emits: ['loaded'],

	data() {
		return {
			showText: false
		};
	},

	computed: {
		isMedia(): boolean {
			return (
				!!this.message.image ||
				!!this.message.video ||
				!!this.message.report_url ||
				!!this.message.remote
			);
		},
		isMediaComponent() {
			const data = {
				component: '',
				src: '',
				hosting: ''
			};
			if (this.message.video) {
				data.component = 'MessageVideo';
				data.src = this.message.video;
			}
			if (this.message.remote) {
				data.component = 'MessageVideo';
				data.src = this.message.remote;
				data.hosting = this.message.video_hosting || '';
			}
			if (this.message.image) {
				data.component = 'MessageImage';
				data.src = this.message.image;
			}
			if (this.message.report_url) {
				data.component = 'MessageReport';
				data.src = this.message.report_url;
			}
			return data;
		}
	},

	created() {
		if (this.isMedia) {
			setTimeout(() => {
				this.showText = true;
				this.$emit('loaded', true);
			}, 1000);
		} else {
			this.showText = true;
		}
	}
});
